import type { AnyRecord, AppSelector } from "src/types";
import type { TableId, TableState } from "./types";

const getModel: AppSelector<TableState> = (state) => state.tableModule;

export const getResetSelectionTrigger: AppSelector<boolean, TableId> = (state, id) => getModel(state).resetSelectionTrigger[id];

export const getSavedFilters: AppSelector<AnyRecord, string> = (state, tableName) => getModel(state).filters[tableName];
